import React, { useState } from "react"
import { useQuery } from "@apollo/client"
import CustomCard from "components/Atoms/CustomCard"
import ReactTableHeader from "../Common/ReactTableHeader"
import ReactTable from "react-table"
import TablePagination from "../Molecules/TablePagination"
import Error from "../Common/Error"

const GeneralGrid = ({ query, columns, icon, title, itemLimit }) => {
  const [queryValue, setQueryValue] = useState("")
  const [page, setPage] = useState(0)
  const { data, loading, error } = useQuery(query, {
    variables: {
      query: queryValue,
      first: itemLimit,
      skip: page * itemLimit,
    },
  })
  if (error) {
    return <Error message={error.message} />
  }
  return (
    <CustomCard className="m-3 p-0">
      <ReactTableHeader
        icon={icon}
        title={title}
        onQueryChange={query => {
          setQueryValue(query)
          if (page !== 0) {
            setPage(0)
          }
        }}
        value={queryValue}
        children={<TablePagination page={page} onPageChange={setPage} />}
      />
      <ReactTable
        data={data?.allInwards}
        loading={loading}
        style={{
          height: "80vh",
        }}
        loadingText="Fetching Data..."
        columns={columns}
        showPaginationBottom={false}
        defaultPageSize={itemLimit}
        pageSize={itemLimit}
      />
    </CustomCard>
  )
}
export default GeneralGrid
